import { types } from "../../types/types";

const initialState = {
  items: [],
  itemsAux:[],
  loading: false,
};

function remplazarPorTildeASinTilde(cadena){
  cadena = cadena.replace(/á/gi,"a");
  cadena = cadena.replace(/é/gi,"e");
  cadena = cadena.replace(/í/gi,"i");
  cadena = cadena.replace(/ó/gi,"o");
  cadena = cadena.replace(/ú/gi,"u");
  cadena = cadena.replace("?","");
  return cadena;
}

function filter(text, searchString) {
  const regexStr = '(?=.*' + searchString.split(/\s+/).join(')(?=.*') + ')'; //anterior /\,|\s/
  const searchRegEx = new RegExp(regexStr, 'gi');
  return text.match(searchRegEx) !== null;
}

export const especialidadAbmReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.abmEspecialidadTraerStart:
      return {
        ...state,
        loading: true,
      };
    case types.abmEspecialidadTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        itemsAux: action.payload
      };
    case types.abmEspecialidadTraerError:
      return {
        ...state,
        loading: false,
        items: [],
      };
    case types.abmEspecialidadBuscar:
      return {
        ...state,
        loading: true,
        items: state.itemsAux.filter(n => filter(remplazarPorTildeASinTilde(n.descripcionEspecialidades),remplazarPorTildeASinTilde(action.payload)))
      };
    default:
      return state;
  }
};